import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { t } from 'i18next';

/**
 * A functional component that renders an input field for the professional certificate.
 */
export const TextFieldProfessionalCertificate = ({ values, handleChange }) => (
    <TextField
        fullWidth
        label={t('users.fields.professionalId')}
        type="tel"
        name="professionalCertificate"
        value={values.professionalCertificate}
        onChange={handleChange}
    />
);

TextFieldProfessionalCertificate.propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired
};
